import { defineStore } from 'pinia';
import axiosInstance from '../plugins/axios';

interface Flag {
  id: string;
  name: string;
  currentValue: boolean;
}

interface FlagChange {
  id: string;
  previousValue: boolean;
  newValue: boolean;
}

export const useFlagStore = defineStore(
  'flags',
  {
    state: () => ({
      flags: [] as Flag[],
      changeHistory: [] as FlagChange[][],
      currentHistoryIndex: -1,
      reportID: '' // Neu: Speichert die zurückgegebene Report-ID
    }),
    getters: {
      getAllFlagsSummary: (state) => {
        return state.flags.map(flag => ({
          id: flag.id,
          name: flag.name,
          currentValue: flag.currentValue
        }));
      }
    },
    actions: {
      async initializeStore() {
        try {
          const response = await axiosInstance.get('/flags');
          this.flags = response.data.map((flag: any) => ({
            id: flag._id,
            name: flag.name,
            currentValue: flag.startingValue 
          }));
          this.changeHistory = [];
          this.currentHistoryIndex = -1;
          this.reportID = ''; // Neu: Setzt reportID zurück
        } catch (error) {
          console.error('Failed to initialize flags:', error);
        }
      },

      updateFlags(changeFlags: Array<{id: string, newValue: boolean}> | null) {
        const changes: FlagChange[] = [];
        
        if (changeFlags) {
          changeFlags.forEach(flagToChange => {
            this.flags.forEach(flag => {
              if (flag.id === flagToChange.id && flag.currentValue !== flagToChange.newValue) {
                changes.push({
                  id: flag.id,
                  previousValue: flag.currentValue,
                  newValue: flagToChange.newValue
                });
                flag.currentValue = flagToChange.newValue;
              }
            });
          });
        }
      
        if (this.currentHistoryIndex < this.changeHistory.length - 1) {
          this.changeHistory = this.changeHistory.slice(0, this.currentHistoryIndex + 1);
        }
      
        this.changeHistory.push(changes);
        this.currentHistoryIndex++;
      },

      getFlag(name: string) {
        const flag = this.flags.find(flag => flag.name === name);
        return flag ? flag.currentValue : undefined;
      },

      async saveFlagsToDB() {
        try {
          const flagsForDB = this.flags.map(flag => ({
            flagID: flag.id, 
            name: flag.name,
            currentValue: flag.currentValue
          }));
      
          const response = await axiosInstance.post('/reports', {
            flags: flagsForDB
          });
          
          console.log('Flags saved successfully:', response.data);
          
          this.reportID = response.data._id;
          console.log('Report ID saved:', this.reportID);
          return response.data._id;
        } catch (error) {
          console.error('Failed to save flags:', error);
        }
      },

      goBack() {
        const revertedChanges: Array<{name: string, oldValue: boolean, newValue: boolean}> = [];
        
        if (this.currentHistoryIndex >= 0) {
          const lastChanges = this.changeHistory[this.currentHistoryIndex];
          lastChanges.forEach(change => {
            const flag = this.flags.find(flag => flag.id === change.id);
            if (flag) {
              revertedChanges.push({
                name: flag.name,
                oldValue: change.newValue, 
                newValue: change.previousValue 
              });
      
              flag.currentValue = change.previousValue;
            }
          });
      
          this.currentHistoryIndex--;
        } else {
          console.warn('No more history to go back.');
        }
      
        console.log(revertedChanges)
        return revertedChanges;
      }
    }
  }
);
